__turbopack_context__.v({
  "link": "search-jobs-button-module-scss-module__Roz6lW__link",
});
